"use client";
import { useState, useEffect, useRef } from "react";
import axios from "axios";

const LiveSearch = () => {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);

  const inputRef = useRef(null);
  const debounceRef = useRef(null);

  // Debounce + Fetch Suggestions
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!query || query.trim().length < 2) {
      setResults([]);
      setLoading(false);
      return;
    }

    debounceRef.current = setTimeout(() => {
      fetchResults(query);
    }, 400);

    return () => clearTimeout(debounceRef.current);
  }, [query]);

  const fetchResults = async (q) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/keyword/products/search?query=${encodeURIComponent(q)}`
      );
      setResults(res.data.products || []);
      setShowDropdown(true);
    } catch (err) {
      console.error("Search Error:", err);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  const selectResult = (product) => {
    setQuery(product.name);
    setShowDropdown(false);
    window.location.href = `/product-details/${product._id}`;
  };

  return (
    <>
      <style>{`
        /*  Responsive Styling */
        .live-search-container {
          position: relative;
          width: 70%;
        }

        .search-input {
          width: 100%;
          border: 1px solid #ddd;
          border-radius: 50px;
          padding: 10px 45px 10px 15px;
          font-size: 14px;
          transition: 0.2s;
        }

        .search-input:focus {
          outline: none;
          border-color: #df4928;
          box-shadow: 0 0 0 2px rgba(0,178,7,0.15);
        }

        .search-btn {
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          width: 32px;
          height: 32px;
          background: #df4928;
          border: none;
          border-radius: 50%;
          color: white;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .results-dropdown {
          position: absolute;
          top: 110%;
          left: 0;
          right: 0;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          max-height: 250px;
          overflow-y: auto;
          z-index: 50;
        }

        .results-item {
          padding: 10px 12px;
          cursor: pointer;
          border-bottom: 1px solid #f3f4f6;
        }

        .results-item:hover {
          background: #f9fafb;
        }

        .results-item .name {
          font-size: 14px;
          font-weight: 500;
          color: #111;
        }

        .results-item .desc {
          font-size: 12px;
          color: #6b7280;
        }

        @media (max-width: 768px) {
          .live-search-container {
            width: 100%;
            margin-top: 0px;
          }
          .search-input {
            font-size: 13px;
            padding: 8px 40px 8px 12px;
          }
          .results-dropdown {
            max-height: 200px;
            font-size: 13px;
          }
        }
      `}</style>

      <div className="live-search-container">
        <input
          ref={inputRef}
          type="text"
          placeholder="Search products..."
          className="search-input"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onFocus={() => setShowDropdown(true)}
          onBlur={() => setTimeout(() => setShowDropdown(false), 200)}
        />

        <button type="button" className="search-btn">
          <i className="ph ph-magnifying-glass" />
        </button>

        {loading && <div className="text-gray-500 text-xs mt-1">Searching…</div>}

        {showDropdown && results.length > 0 && (
          <ul className="results-dropdown">
            {results.map((p) => (
              <li
                key={p._id}
                className="results-item"
                onClick={() => selectResult(p)}
              >
                <div className="name">{p.name}</div>
                <div className="desc">
                  {p.description?.slice(0, 50) || "No description"}
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default LiveSearch;
